import { render } from "./CustomerCreate.vue?vue&type=template&id=3a1c2ccb&scoped=true&ts=true"
import script from "./CustomerCreate.vue?vue&type=script&lang=ts"
export * from "./CustomerCreate.vue?vue&type=script&lang=ts"

import "./CustomerCreate.vue?vue&type=style&index=0&id=3a1c2ccb&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web-staging/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a1c2ccb"]])

export default __exports__